module.exports = __webpack_public_path__ + "assets/images/icons/condo.svg?v=359bc0d0";